<template>
  <AgsLink
    v-if="showGoldnerClub && !fetching"
    :to="toLocalePath(goldnerClubSubscribeRedirectURL)"
    type="whisper"
    :aria-label="$t('navigation.goldner_club_label')"
    @click="$emit('click:link', toLocalePath(goldnerClubSubscribeRedirectURL))"
  >
    <span>
      {{ $t('navigation.goldner_club') }}
    </span>
  </AgsLink>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import useGoldnerClub from '~/composables/useGoldnerClub'
import { useUser } from '#storefront/composables'
import useRouteHelpers from '#layers/base/composables/useRouteHelpers'
import { routeList } from '~/utils/route'
import type { RouteLocationRaw } from '#vue-router'

defineEmits<{ 'click:link': [value: string | RouteLocationRaw] }>()

const { isLoggedIn } = useUser({ key: 'useAgsUser' })
const { toLocalePath } = useRouteHelpers()
const { showGoldnerClub } = useExperiments()
const { data: membershipData, fetching } = useGoldnerClub()

const isMember = computed(() => membershipData.value?.isClubMember)
const isPending = computed(
  () => membershipData.value?.userRegistrationStatus === 'pending',
)

const goldnerClubSubscribeRedirectURL = computed(() => {
  if (!isLoggedIn.value) {
    return routeList.goldnerClubEntryPage.path
  }
  if (isMember.value) {
    return routeList.goldnerClub.path
  }
  if (isPending.value) {
    return routeList.goldnerClubThankYouPage.path
  }
  return routeList.goldnerClubSubscribePage.path
})
</script>
